import api, { formatApiError, getErrorMessage } from "@/lib/api";

async function fetchBlob(paymentId) {
  const res = await api.get(`/payments/${paymentId}/receipt`, { responseType: "blob" });
  return res.data;
}

async function parseErr(e) {
  const data = e?.response?.data;
  if (data instanceof Blob) {
    try { const j = JSON.parse(await data.text()); return formatApiError(j.detail); } catch { /* fallthrough */ }
  }
  return getErrorMessage(e);
}

// Returns { blob } on success or { error } with a readable message.
export async function getReceiptBlob(paymentId) {
  try { return { blob: await fetchBlob(paymentId) }; }
  catch (e) { return { error: await parseErr(e) }; }
}

// Trigger a download; falls back to opening the PDF in a new tab if the browser
// blocks the anchor download (some Android in-app browsers / iOS Safari).
export function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  if ("download" in a) {
    a.href = url; a.download = filename;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 5000);
    return true;
  }
  const w = window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 15000);
  return !!w;
}

// Share via the Web Share API (WhatsApp etc.). Returns false if unsupported/cancelled.
export async function shareBlob(blob, filename) {
  try {
    const file = new File([blob], filename, { type: "application/pdf" });
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({ files: [file], title: "PM POSHAN Receipt", text: "PM POSHAN payment receipt" });
      return true;
    }
  } catch { /* cancelled or unsupported */ }
  return false;
}

export const receiptName = (id) => `PM_POSHAN_Receipt_${id || "receipt"}.pdf`;
